import { H2 } from "components/atoms/Heading";
import { Text } from "react-bricks";
import styled, { css } from "styled-components";
import { mobile, tablet } from "components/templates/Breakpoints";
import { ComponentProps } from "react";

type Props = ComponentProps<typeof Text> & {
  color?: string;
  padBottom?: boolean;
};

const TextHeading: React.FC<Props> = ({ padBottom, color, ...props }) => {
  return (
    <Text
      {...props}
      renderBlock={({ children }) => (
        <Title align={"center"} color={color} padBottom={padBottom}>
          {children}
        </Title>
      )}
    />
  );
};

export default TextHeading;

const Title = styled(H2)<{
  $titleFontSize?: [string, string, string];
  padBottom: boolean;
}>`
  margin-bottom: ${(p) => (p.padBottom ? `1.5rem` : `0`)};
  ${(p) =>
    p.$titleFontSize &&
    css`
      font-size: ${p.$titleFontSize[0]};

      ${tablet} {
        font-size: ${p.$titleFontSize[1]};
      }

      ${mobile} {
        font-size: ${p.$titleFontSize[2]};
      }
    `}
`;
